const SELLER_PUBLIC_PATHS = ["/seller", "/sellerhome", "/sellerlogin"];
const SELLER_PROTECTED_PATHS = ["/dashboard", "/sellersetting"];
const SELLER_PROTECTED_PREFIXES = ["/seller/"];

export const normalizePathname = (pathname = "") => {
  const normalized = String(pathname || "").trim().toLowerCase();

  if (!normalized || normalized === "/") {
    return normalized || "/";
  }

  return normalized.replace(/\/+$/, "");
};

export const isSellerPublicPath = (pathname = "") =>
  SELLER_PUBLIC_PATHS.includes(normalizePathname(pathname));

export const isSellerProtectedPath = (pathname = "") => {
  const normalizedPath = normalizePathname(pathname);

  if (SELLER_PROTECTED_PATHS.includes(normalizedPath)) {
    return true;
  }

  return SELLER_PROTECTED_PREFIXES.some((prefix) =>
    normalizedPath.startsWith(prefix),
  );
};

export const isSellerPath = (pathname = "") =>
  isSellerPublicPath(pathname) || isSellerProtectedPath(pathname);
